function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#9399AC",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 3.5C3 1.6 4.6 0 6.5 0S10 1.6 10 3.5 8.4 7 6.5 7 3 5.4 3 3.5zM6.5 9c4.9 0 6.5 5 6.5 5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2s1.6-5 6.5-5z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 8c0-.552-.443-1-.999-1H19V4.999A.997.997 0 0 0 18 4c-.552 0-1 .443-1 .999V7h-2.001A.997.997 0 0 0 14 8c0 .552.443 1 .999 1H17v2.001c0 .552.444.999 1 .999.552 0 1-.443 1-.999V9h2.001A.997.997 0 0 0 22 8z"
}));

var SvgAddPerson = function SvgAddPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddPerson.d6a7a581.svg";
export { ForwardRef as ReactComponent };